export class PagingDataView {
    public no: number;
    public id: string;
    public seriesId: string;
    public name: string;
}